import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import { Button as Buttons } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import { iotOrderForm } from '../../../../utils/constant';
import { Button } from './css';
import ConfirmationBox from '../../../../design/shared/ConfirmationBox';
import { ButtonBox } from '../../../../salesRepDashboard/Actions/css';

const Continue = ({ orderData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { confirmationDialog, continueLabel },
    formButtons: { confirmButtonLabel, cancelButtonLabel },
    BUSINESS_APP_ORDERS: { orderContinueConfirmation }
  } = localizedStrings;
  const { locale, categoryName, id, isQuoteReference } = orderData;
  const history = useHistory();

  const handleModifyQuote = () => {
    history.push({
      pathname: `/${locale}/${categoryName}/${iotOrderForm}`,
      search: `?orderId=${id}`
    });
    window.location.reload();
  };

  if (isQuoteReference) return null;

  return (
    <>
      <Button className="action-button" onClick={() => setIsModalOpen(true)}>
        {continueLabel}
      </Button>
      <ConfirmationBox
        open={isModalOpen}
        hideCloseButton={!isModalOpen}
        setOpen={() => isModalOpen}
        header={confirmationDialog}
        onClose={() => setIsModalOpen(false)}
      >
        <p style={{ fontSize: '15px', padding: '8px 0' }}>{orderContinueConfirmation}</p>
        <ButtonBox>
          <Buttons variant={{ priority: 'high' }} onPress={() => handleModifyQuote()} >{confirmButtonLabel}</Buttons>
          <Buttons variant={{ priority: 'low' }} onPress={() => setIsModalOpen(false)}>{cancelButtonLabel}</Buttons>
        </ButtonBox>
      </ConfirmationBox>       
    </>
  );
};

Continue.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

export default Continue;
